import { useEffect, useState } from "react";
import { Enum_ValidationString, checkValidationRequiredString, goTo } from "../../utilities/common.utilities";
import "./recoveryPassword.css";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { forgotPassword } from "../../service/forgotPassword.service";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toolbar } from "primereact/toolbar";
import ShareComponent from "../Share/share.component";
import { SpecialZoomLevel, ViewMode, Viewer } from "@react-pdf-viewer/core";
import LoadingSpinner from "../loading-spinner/loading-spinner";
import { Worker } from '@react-pdf-viewer/core';
import { MAXLENGTH_EMAIL } from "../../static/constants";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import { forgotPasswordUserResponseModel } from "../../static/forgotPassword.model";
import { ListBox } from "primereact/listbox";
import {installPWA, onClickInstallButton, pwaInstalled} from "../../utilityPWA";
import PopupInstallComponent from "../PopupInstall/popupInstall.component";
import FooterPreLoginComponent from "../Footer/footer-pre-login.component";
import { useConnectivity } from "../../context/connectivityContext";

type EmailInfoStatus = {
    Value: string;
    Valid: boolean;
    ShowError: boolean;
}

export default function RecoveryPasswordComponent() {

  const [infoInput, setInfoInput] = useState<EmailInfoStatus>({ Value: '', Valid: false, ShowError: false});

  // State per sezione "Scegli account"
  const [showAccountList, setShowAccountList] = useState<boolean>(false);
  const [accountList, setAccountList] = useState<forgotPasswordUserResponseModel[]>([]);
  const [accountSelected, setAccountSelected] = useState<string>('');

  // Visualizza il popup di esito (invio email)
  const [showDialog, setShowDialog] = useState<boolean>(false); 
  const [emailSendLink, setEmailSendLink] = useState<string>(''); 


  // State per footer
  const [showSharingComponent, setShowSharingComponent] = useState<boolean>(false);
  const [showTermsOfUse, setShowTermsOfUse] = useState<boolean>(false);
  const [showPopupInstall, setShowPopupInstall] = useState<boolean>(false);
  const { isOnline } = useConnectivity();

  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore
  useEffect(() => {}, [isOnline]);  


  const updateInfoInput = (value: string | null, showError?: boolean): void => {

    let valueCheck: string = (value == null) ? infoInput.Value : value;
    valueCheck = valueCheck ? valueCheck.replaceAll(' ','') : ''; 

    let newInfoStatus: EmailInfoStatus = {
        Value: valueCheck,
        Valid: checkValidationRequiredString(valueCheck, Enum_ValidationString.Any),
        ShowError: infoInput.ShowError
    }

    if(showError) {
      newInfoStatus.ShowError = true
    }

    setInfoInput(newInfoStatus);

  }

  const getErrorInput = (): string => {
    let messageError: string = '';

    if(!infoInput.Value) {
      messageError = 'Campo Obbligatorio';
    }

    return messageError;
  }

  const disableButton = (): boolean => {

    let disable: boolean;
    if(showAccountList) {
      disable = !accountSelected
    }
    else {
      disable = (infoInput.Value && infoInput.Valid) ? false : true;
    }

    return disable;
  }

  const recoveryPassword = () => {
    // Se è mostrato il campo di input "Username/Email" 
    if(!showAccountList) {
      // Prendo il valore dell' input, lo controllo e l' ho invio al server
      if(infoInput.Value && infoInput.Valid) {
        // showConfirm(infoInput.Value);
        sendLinkResetPassword(infoInput.Value);
      }
    }
    // Altrimenti prendo il valore dalla dropdown
    else if(accountSelected) {
      // showConfirm(accountSelected);
      sendLinkResetPassword(accountSelected);
    }
  }



  // const showConfirm = (value: string) => confirmDialog({
  //   tagKey: 'confirmReset',
  //   message: 'Vuoi reimpostare la password del tuo account?',
  //   header: "Conferma operazione",
  //   acceptLabel: "Si",
  //   modal: true,
  //   accept: async () => {
  //     sendLinkResetPassword(value)
  //   }
  // })

  const sendLinkResetPassword = (value: string) => {
    forgotPassword(value).then((response: any) => {

      // Se scegliendo un' email, ha restituito una lista di username
      if(response?.status === 300) {
        setShowAccountList(true);
        let users: forgotPasswordUserResponseModel[] = (response.data.users as forgotPasswordUserResponseModel[]);

        users.sort((u1,u2) => (u1.signInName > u2.signInName ? 1 : -1)); // ordinamento alfabetico su signInName
        setAccountList(response.data.users);
      }

      else if(response?.status === 200) {
        let emailLink: string = response.data.email;
        setEmailSendLink(emailLink);
        setShowDialog(true)
      }

    })
  }

  const usernameOptionTemplate = (option: forgotPasswordUserResponseModel) => {
    return (
      <div className="grid">
        <div className="col-1">
          <div className="flex align-items-center justify-content-center h-full">
            {accountSelected === option.signInName ? (
              <i
                className="pi pi-check text-secondary pr-1"
                style={{ fontSize: "1rem" }}
              ></i>
            ) : (
              <i className=""></i>
            )}
          </div>
        </div>

        {/* <div className="col-2">
          <div className="flex align-items-center justify-content-end h-full">
            <i style={{ fontSize: '1rem' }}
              className={ 'pi pi-user ' + (accountSelected === option.signInName ? 'icon-element-selection' : 'text-color-secondary')}>
            </i>
          </div>
        </div> */}


        <div className="col-11 flex align-items-center justify-content-start">

          <div className="flex align-items-center justify-content-start h-full mr-3">
            <i style={{ fontSize: '1.5rem' }}
              className={ 'pi pi-user ' + (accountSelected === option.signInName ? 'icon-element-selection' : 'text-color-secondary')}>
            </i>
          </div>

          <div className="flex flex-column justify-content-center">
            <div>
              <b>
                {option.signInName}
              </b>
            </div>

            <div className="flex align-items-center justify-content-center w-full mt-1">
              <small className="">
                <span> Registrato il </span>
                <b>
                  { moment(option.profileCreationDate).format('DD/MM/YYYY') }
                </b>
              </small>
            </div>
          </div>
        </div>

     
      </div>
    );
  }

  const headerElement = (
    <div className="inline-flex align-items-center justify-content-center gap-2">
      <span className="font-bold">Operazione eseguita con successo</span>
    </div>
  );

  const footerContent = (
    <div>
      <Button
        label="Ok"
        icon="pi pi-check"
        onClick={() => {setShowDialog(false); goTo("/login")} }
        autoFocus
      />
    </div>
  );

  return (
    <>
      <PopupInstallComponent openManually={true} showBehaviorManually={showPopupInstall} 
        onClosePopup={() => {
          if(showPopupInstall) {
              setShowPopupInstall(false)
          }}
        }
      />
      <div className="header-recovery-password">

        <div className="grid title-recovery-password mt-1">

        <div className="col-2 flex align-items-center justify-content-start pl-4">

          <div className="flex flex-column" style={{cursor:'pointer'}} onClick={() => {
              if(!showAccountList) {
                goTo("/login"); 
              }
              else {
                setAccountSelected('');
                setShowAccountList(false);
              }
              }}>
                <div className="flex align-items-center justify-content-center text-white">
                  <i className="pi pi-arrow-left icons-header"></i>         
                </div>
                <div className="flex align-items-center justify-content-center font-bold text-white" 
                  style={{  position: 'relative', top: '-5px' }} >
                    <label style={{ fontSize: '8px', fontWeight: 'bold' }} htmlFor="backLoginButton">INDIETRO</label>
                </div>
            </div>

        </div>

        <div className="col-8 flex align-items-center justify-content-center">

          {
            process.env.REACT_APP_SUFFIX_TITLE_HEADER
            ? 
            <div className="flex flex-column mt-1">
              <div>Recupera password</div>

              <div className="flex justify-content-end text-sm font-normal">
                <div className="flex align-items-center justify-content-center title-login">
                    {process.env.REACT_APP_SUFFIX_TITLE_HEADER}
                </div>
              </div>
            </div>
            :
            <span className="mb-3 mt-2">Recupera password</span> 
          }

          </div>
        </div>
      </div>

      <div className="content-recovery-password">

      <ConfirmDialog tagKey="confirmReset"/>
        <div className="flex flex-column gap-5">{/*md:flex-row*/}
          <div className="w-full flex flex-column align-items-center justify-content-center gap-5 py-5">{/*md:w-5*/}
            <div className="flex flex-wrap justify-content-center align-items-center gap-5">

              {
                showAccountList
                ?
                <div className="px-2">
                  <h1 style={{ textAlign: 'center' }}>
                   Seleziona Account
                  </h1>

                  <p className="text-recovery-password">
                    Sono stati trovati più utenti.<br/>Ripetere la richiesta utilizzando l'username
                  </p>
                </div>
                :
                <div className="px-2">
                  <h1 style={{ textAlign: 'center' }}>
                    Password dimenticata?
                  </h1>

                  <p className="text-recovery-password">
                    Per reimpostare la password,<br />inserisci l'username o l'email<br/>collegati al tuo account.
                  </p>
                </div>
              }
             

              <div className="flex flex-column flex-wrap justify-content-center align-items-center gap-5 mt-3 w-full">
                <div className="flex flex-column" style={{width: '75%'}}>
                
                  {
                    showAccountList
                    ?
                    <>
                      {/* <span className="p-float-label">
                        <Dropdown 
                          style={{width: '100%'}}
                          value={accountSelected}
                          onChange={(e) => setAccountSelected(e.value)}
                          options={accountList}
                          optionValue="signInName"
                          optionLabel="signInName"
                          placeholder="Seleziona un account..."
                          itemTemplate={usernameOptionTemplate}
                          panelClassName="recovery-password-dropdown-popup"
                        />

                        <label htmlFor="UsernameList">Username</label>
                      </span> */}
                      {/* <label className="mb-2 mx-auto">Username</label> */}
                      <div className="flex justify-content-center">
                        <ListBox  
                          className="listboxAccount"
                          value={accountSelected}
                          onChange={(e) => setAccountSelected(e.value)}
                          options={accountList}
                          optionValue="signInName"
                          optionLabel="signInName"
                          itemTemplate={usernameOptionTemplate}
                        />
                      </div>
                    </>
                    :
                    <>
                      <span className="p-float-label">

                        <InputText
                        className="input-recovery-password"
                          style={{width: '100%'}}
                          value={infoInput.Value}
                          onChange={(e) => { updateInfoInput(e.target.value); }}
                          onKeyUp={(e) => {
                            if(e.key === 'Enter' && (!disableButton())) {
                              recoveryPassword();
                            }
                          }}
                          invalid={infoInput.ShowError && (!infoInput.Valid)}
                          onBlur={() => { updateInfoInput(null,true); }}
                          maxLength={MAXLENGTH_EMAIL}
                        />
                        <label className="label-recovery-password" htmlFor="Username/Email">Username/Email</label>

                      </span>

                      {
                        infoInput.Valid || (!infoInput.ShowError) 
                        ?
                        <></> 
                        : 
                        <span>
                          <small className="text-red-600"> {getErrorInput()} </small>
                        </span>
                      }
                    </>
                    } 

                </div>
              </div>

              
              <Button id="reset-password" onClick={() => recoveryPassword()} label="Reimposta password" 
                disabled={disableButton()} style={{borderRadius: '24px'}} className="w-20rem mx-auto">
              </Button>

              <Dialog
                  visible={showDialog}
                  modal
                  header={headerElement}
                  footer={footerContent}
                  style={{ width: "22rem" }}
                  onHide={() => { setShowDialog(false); goTo('/login')}}
                >
                  <p>
                    Il link per il cambio password è stato inviato all' indirizzo email
                    <br />
                    
                    <b> { emailSendLink.replace(/(^.)(.*)(.@.*$)/, (match, p1, p2, p3) => {
                              return p1 + p2.replace(/./g, '*') + p3;
                          }) 
                        }
                    </b>
                  </p>
                </Dialog>

            </div>
          </div>
        </div>
      </div>

      <FooterPreLoginComponent />
    </>
  );
}
